import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import styled from "styled-components";
import { Label, Dropdown, Grid, Button } from "~/components-shared";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref2 => {
  let {
    $fullWidth
  } = _ref2;
  return $fullWidth && "width: 100%";
}};
  ${_ref3 => {
  let {
    $maxWidth
  } = _ref3;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
`;
const Error = styled.span`
  font-size: 0.8rem;
  display: inline-block;
  margin-left: 0.5rem;
  color: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.danger.main;
}};
`;
const EmojiButton = styled.button`
  width: 2.3rem;
  height: 2.3rem;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  ${_ref5 => {
  let {
    $selected,
    theme
  } = _ref5;
  return theme.shadows.outline(theme, $selected);
}}

  &:hover {
    ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.shadows.outline(theme, true);
}}
  }
`;
const StyledDropdownList = styled(Dropdown.List)`
  width: 220px;
`;
const InputEmojiSimple = _ref7 => {
  let {
    label,
    value = "",
    direction = "bottomRight",
    error,
    onChange = () => false,
    required = false,
    disabled = false,
    maxWidth,
    fullWidth = false,
    s,
    outline,
    children,
    labelProps,
    ...rest
  } = _ref7;
  const [emojis] = useState(["", "📅", "❤️", "✋", "🤝", "🎯", "✏️", "📬", "✈️", "🌴", "😍", "😴", "😷", "🤒", "🤕", "🤫", "😡", "😠", "🤬", "🗓️", "😋", "🥘", "🍲", "🥫", "🧠", "🎉", "☝️", "🐈", "👋", "🦷"]);
  const customHandler = toggle => /*#__PURE__*/React.createElement(Button, _extends({
    color: "primaryTransparent",
    outline: false,
    onClick: toggle,
    fontSize: 6,
    rounded: true,
    s: {
      p: 1
    }
  }, rest), value || "➕");
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s,
    $maxWidth: maxWidth,
    $fullWidth: fullWidth
  }, !!label && /*#__PURE__*/React.createElement(Label, _extends({
    required: required,
    disabled: disabled
  }, labelProps), label), /*#__PURE__*/React.createElement(Dropdown, {
    direction: direction,
    customHandler: customHandler
  }, _ref8 => {
    let {
      isOpen,
      onItemClick
    } = _ref8;
    return /*#__PURE__*/React.createElement(StyledDropdownList, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Grid, {
      cols: 5,
      gap: 3,
      s: {
        p: 3
      }
    }, emojis.map(emoji => /*#__PURE__*/React.createElement(EmojiButton, {
      key: emoji,
      $selected: emoji === value,
      onClick: () => {
        onItemClick();
        onChange(emoji);
      }
    }, emoji))));
  }), error && /*#__PURE__*/React.createElement(Error, null, error));
};
export default InputEmojiSimple;